import * as React from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

export default function ReleaseFilters({
  availableTypes,
  typeFilter,
  searchTerm,
  onTypeChange,
  onSearchChange,
}) {
  return (
    <section className="release-filter-bar" aria-label="Release filters">
      <div className="release-type-filter" aria-label="Release type">
        {availableTypes.map((type) => (
          <button
            className={`release-type-filter__button ${
              typeFilter === type ? "release-type-filter__button--active" : ""
            }`}
            key={type}
            onClick={() => onTypeChange(type)}
            type="button"
          >
            {type}
          </button>
        ))}
      </div>

      <TextField
        className="release-search"
        label="Search release notes"
        onChange={(event) => onSearchChange(event.target.value)}
        size="small"
        value={searchTerm}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
      />
    </section>
  );
}
